export default "__VITE_ASSET__DSZJ54mR__"